export var FIELD_I18N_KEY;
(function (FIELD_I18N_KEY) {
    FIELD_I18N_KEY["patent"] = "commonPatent";
    FIELD_I18N_KEY["paper"] = "commonPaper";
    FIELD_I18N_KEY["mr"] = "commonMerger";
    FIELD_I18N_KEY["vc"] = "commonInvestment";
    FIELD_I18N_KEY["ma"] = "commonMarket";
})(FIELD_I18N_KEY || (FIELD_I18N_KEY = {}));
export var FIELD_TYPE;
(function (FIELD_TYPE) {
    FIELD_TYPE["STANDARD"] = "standard";
    FIELD_TYPE["CUSTOM"] = "custom";
})(FIELD_TYPE || (FIELD_TYPE = {}));
